import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

function SettingsTabs() {

    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = location.pathname;
  return (
    <div className='knowledgetab_btnredirect'>
        <button className={currentPath.startsWith("/settings/general") ? "active_tabbtn" : ""} onClick={() =>{navigate(`/settings/general`)}}>General</button>
        <button className={currentPath.startsWith("/settings/onboarding") ? "active_tabbtn" : ""} onClick={() =>{navigate(`/settings/onboarding`)}}>Onboarding</button>
        <button className={currentPath.startsWith("/settings/smtp") ? "active_tabbtn" : ""} onClick={() =>{navigate(`/settings/smtp`)}}>SMTP</button>
        <button className={currentPath.startsWith("/settings/s3-file-system") ? "active_tabbtn" : ""} onClick={() =>{navigate(`/settings/s3-file-system`)}}>S3 File System</button>
        <button className={currentPath.startsWith("/settings/payment") ? "active_tabbtn" : ""} onClick={() =>{navigate(`/settings/payment`)}}>Payment</button>
        <button className={currentPath.startsWith("/settings/social-links") ? "active_tabbtn" : ""} onClick={() =>{navigate(`/settings/social-links`)}}>Social Links</button>
        <button className={currentPath.startsWith("/settings/update-terms") ? "active_tabbtn" : ""} onClick={() =>{navigate(`/settings/update-terms`)}}>Terms & Conditions</button>
    </div>
  )
}

export default SettingsTabs
